import { render, staticRenderFns } from "./EditActionItem.vue?vue&type=template&id=9c842542&scoped=true"
import script from "./EditActionItem.vue?vue&type=script&lang=js"
export * from "./EditActionItem.vue?vue&type=script&lang=js"
import style0 from "./EditActionItem.vue?vue&type=style&index=0&id=9c842542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c842542",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VChip,VForm,VIcon,VTooltip})
